<template>
  <v-dialog v-model="show" max-width="600px" persistent>
    <v-card>
      <v-card-title class="headline error white--text d-flex align-center">
        <v-icon left color="white">mdi-alert-circle</v-icon>
        Validation Error
      </v-card-title>
      <v-card-text class="pt-4 pb-2">
        <p class="subtitle-1 mb-3">{{ message }}</p>
        <v-alert
          v-if="Object.keys(errors).length > 0"
          dense
          outlined
          type="error"
          class="mb-0"
        >
          <div class="text-body-2">
            <div v-for="(error, field) in errors" :key="field" class="mb-2">
              <strong>{{ formatFieldName(field) }}:</strong> {{ error }}
            </div>
          </div>
        </v-alert>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="close">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ValidationErrorDialog',
  computed: {
    show() {
      return this.$store.state.validationDialog;
    },
    message() {
      return this.$store.state.validationMessage;
    },
    errors() {
      return this.$store.state.validationErrors || {};
    }
  },
  methods: {
    close() {
      this.$store.commit('clearValidationDialog');
    },
    formatFieldName(field) {
      // Convert snake_case to Title Case
      // oracle_site_number → Oracle Site Number
      return field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/util/ValidationErrorDialog.vue